import { useEffect, useRef } from "react";
import { S } from "../../utils/styles";
import { logWriteTrace } from "../../utils/writeTrace";

export default function AppHeader({
    title,
    showLogTimer,
    timerLeft,
    onTimerClick,
    isDark,
    onToggleTheme,
    showSettingsButton = false,
    onOpenSettings,
    showCalendarButton = false,
    onOpenCalendar,
}) {
    const headerRef = useRef(null);

    // position: fixed なので ResizeObserver はスクロール中にトリガーされない。
    // 正確なヘッダー高さを CSS 変数に反映し、コンテンツの paddingTop と
    // コンパクトバーの top 位置の両方に使う。
    useEffect(() => {
        const el = headerRef.current;
        if (!el) return;
        const update = () => {
            const root = document.documentElement;
            const newH = el.getBoundingClientRect().height;
            const prevH = parseFloat(root.style.getPropertyValue("--app-header-height")) || 0;
            const safeTop = parseFloat(root.style.getPropertyValue("--safe-top")) || 0;
            // Loop-safe: applySafeAreas may already have written the correct value
            // via its defensive re-measure. Skip write when value is unchanged.
            const changed = Math.round(newH) !== Math.round(prevH);
            if (changed) {
                root.style.setProperty("--app-header-height", `${newH}px`);
            }
            logWriteTrace("appHeader:measure", {
                date: null,
                decision: "executed",
                extra: {
                    measuredHeight: newH,
                    safeTop,
                    writtenHeight: changed ? newH : null,
                    prevHeight: prevH,
                },
            });
        };
        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    return (
        <div ref={headerRef} data-app-header="true" style={S.header}>
            <div>
                <div style={S.appLabel}>PUMP</div>
                <div style={S.headerTitle}>{title}</div>
            </div>
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                {showSettingsButton && (
                    <button
                        type="button"
                        onClick={onOpenSettings}
                        style={S.pillBtn}
                        aria-label="設定を開く"
                    >
                        ⚙️
                    </button>
                )}
                {showCalendarButton && (
                    <button
                        type="button"
                        onClick={onOpenCalendar}
                        style={S.pillBtn}
                        aria-label="カレンダーを開く"
                    >
                        📅
                    </button>
                )}
                {showLogTimer && (
                    <button
                        onClick={onTimerClick}
                        style={{
                            padding: "9px 13px",
                            borderRadius: 999,
                            fontSize: 12,
                            fontWeight: 800,
                            border: timerLeft !== null ? "1px solid transparent" : "1px solid rgba(18, 199, 194, 0.12)",
                            background: timerLeft !== null ? (timerLeft === 0 ? "linear-gradient(135deg, var(--accent), #4ADE80)" : timerLeft <= 10 ? "linear-gradient(135deg, #ef4444, #fb7185)" : "linear-gradient(135deg, var(--accent2), #7DD3FC)") : "linear-gradient(180deg, var(--card), var(--card2))",
                            color: timerLeft !== null ? "#fff" : "var(--text2)",
                            boxShadow: timerLeft !== null ? "var(--shadow-soft)" : "0 8px 18px rgba(15,94,99,0.08)",
                        }}
                    >
                        {timerLeft !== null ? (timerLeft === 0 ? "GO!💪" : `⏱ ${Math.floor(timerLeft / 60)}:${String(timerLeft % 60).padStart(2, "0")}`) : "⏱"}
                    </button>
                )}
                <button onClick={onToggleTheme} style={S.pillBtn}>{isDark ? "☀️" : "🌙"}</button>
            </div>
        </div>
    );
}
